import { FC, memo, useMemo } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { TableDataQa } from 'commons/types/enums'
import { DataSourceItem, Table } from 'ui/components'
import { Dialog, DialogFace } from 'ui/components/Dialog'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types'

import { columns } from './columns'

interface Props {
  onClose: () => void
}

export const RelatedEntitiesDialog: FC<Props> = memo(({ onClose }) => {
  const routeApi = getRouteApi('/_app/adverse-media/$id')
  const relatedEntities = routeApi.useLoaderData({
    select: (s) => s.relatedEntities
  }) as AdverseMediaDetailsType['relatedEntities']

  const mappedRelatedEntities: DataSourceItem<AdverseMediaDetailsType['relatedEntities'][0]>[] = useMemo(
    () => relatedEntities.map((item) => ({ item })),
    [relatedEntities]
  )

  return (
    <Dialog
      id="search-term-related-entities"
      onClose={onClose}
      face={DialogFace.PRIMARY}
      title="Related Entities"
      headerStyle={{ width: 800 }}
    >
      <Table
        dataQa={TableDataQa.BP_ADVERSE_MEDIA_SEARCH_TERM_RELATED_ENTITIES}
        columns={columns()}
        dataSource={mappedRelatedEntities}
      />
    </Dialog>
  )
})
